import { useState, useRef, useMemo } from "react";
import { useEffect } from "react";
import { apiUrl } from '../../axios';
import swal from 'sweetalert2';
import Select from 'react-select';
import RightSideDetails from "../global/rightSideDetails";
import { deleteBooking, getActiveGreenFeeMaster, getAdminSettlementOptions, getAllGuests, getAllSettlementOptions, getBookingDetails, getGuestByCategoryID, getMemberGuestSubCategories, getShotgunBookSheet, getSubcategories, getTeeTimeBookSheet, postTeeTimeBook, postTeeTimeBookOffline, verifyDate } from "../api/teeTimeAPI";
import ic_check_on from '../../assets/images/ic_check_on.png'
import golf_cart from '../../assets/images/golf_cart.png'
import golf_caddy from '../../assets/images/golf_caddy.png'
import * as helper from '../global/helper';
import AddGuest from "./addGuest";
import AddUser from "./addUser";
import AddPayment from "./addPayment";
import Loading from "../global/loading";
import TaxTableTeeTime from "./taxTableTeeTime";
import moment from "moment";
import { exportToExcel } from "../global/helper";
// import { todayWithTime, today } from "../../assets/scripts/periodSelection";

const BookingSheet = (props) => {

    const [selectedDate,                    setSelectedDate]                    = useState(moment().format("DD-MM-YYYY"));
    const [TeeBoxOption,                    setTeeBoxOption]                    = useState([{ value:  'All', label: 'All'},{ value:  '1', label: '1'}, { value:  '10', label: '10'}]);
    const [typeOption,                      setTypeOption]                      = useState([{ value:  'Member', label: 'Member'}, { value:  'Guest', label: 'Guest'},]);
    const [blockData,                       setBlockData]                       = useState([]);
    const [type,                            setType]                            = useState({'TeeBox': TeeBoxOption[0].label});
    const [teeTimeBookSheet,                setTeeTimeBookSheet]                = useState({});
    const [shotgunBookSheet,                setShotgunBookSheet]                = useState({});
    const [isInit,                          setIsInit]                          = useState(true);
    const [rightSideDetails,                setRightSideDetails]                = useState(false);
    const [bookSheet,                       setBookSheet]                       = useState({});
    const [showAddUser,                     setShowAddUser]                     = useState(false);
    const [showAddGuest,                    setShowAddGuest]                    = useState(false);
    const [usersList,                       setUsersList]                       = useState([]);
    const [MemberList,                      setMemberList]                      = useState([]);
    const [guestList,                       setGuestList]                       = useState([]);
    const [mobileCodeList,                  setMobileCodeList]                  = useState([]);
    const [bookingUserList,                 setBookingUserList]                 = useState([]);
    const [showAddPayment,                  setShowAddPayment]                  = useState();
    const [paymentTagging,                  setPaymentTagging]                  = useState({});
    const [paymentTaggingList,              setPaymentTaggingList]              = useState([]);
    const [bookingTable,                    setBookingTable]                    = useState(null);
    const [loading,                         setLoading]                         = useState(false);
    const [allGuests,                       setAllGuests]                       = useState([]); // set member guest ddl based on selected user
    const [selectedUserGuest,               setSelectedUserGuest]               = useState('');
    const [expandedPaymentDetails,          setExpandedPaymentDetails]          = useState(true);
    const [settlementList,                  setSettlementList]                  = useState([]);
    const [allSettlementList,               setAllSettlementList]               = useState([]);
    const [greenFeeMaster,                  setGreenFeeMaster]                  = useState([]);
    // Vendor bookings: fee rows from the calendar locked at booking time + vendor name (view-only display)
    const [vendorFees,                      setVendorFees]                      = useState([]);
    const [vendorName,                      setVendorName]                      = useState('');
    // const [taxData,                         setTaxData]                         = useState(null);
    const [discountPercentage,              setDiscountPercentage]              = useState(null);
    const [subcategoryList,                 setSubCategoryList]                 = useState([]);
    const [selectedSubCategory,             setSelectedSubCategory]             = useState('');
    const [allGuestsFromServer,             setAllGuestsFromServer]             = useState([]);
    const [filteredGuestsBySubCategory,     setFilteredGuestsBySubCategory]     = useState([]); // set Guest ddl based on selected SubCategory
    const [teeValidationData,               setTeeValidationData]               = useState(null);
    const [selectedGuest,                   setSelectedGuest]                   = useState(null);
    const [serverTS,                        setServerTS]                        = useState(null);
    const [trackingID,                      setTrackingID]                      = useState(null);

    const serverTSRef = useRef(null);
    
    //#region  Effects --------->
    useEffect(() => {
        props.title("Booking Sheet", "tee-sheet")    
        $('#txtDate').datepicker({
            format: 'dd-mm-yyyy',
            minDate: new Date(),
        });  
        $('#txtDate').on('change', function (event) {
            setSelectedDate(event.target.value)
        }); 
    },[])

    useEffect(() => {  
        if(rightSideDetails){
            Config.Core.OpenDrawer()      
            fetchSettlementOptions();
            fetchActiveGreenFeeMaster();
        }else{
            setBookSheet({})
            setBookingUserList([])
            setPaymentTaggingList([])
            setTrackingID(null)
        }
    }, [rightSideDetails]);

    useEffect(() => {
        if(selectedDate){
            //Clear TeeSheet -
            setTeeTimeBookSheet({});
            setShotgunBookSheet({});
            fetchVerifyDate(moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD'))
        }
    },[selectedDate])

    useEffect(() => {       
        if (!isInit) {
            if(type.Type == 'Shotgun'){
                fillShotgunDataTable();
            }else{
                fillDataTable(type.TeeBox);
            }
        }
    }, [type, teeTimeBookSheet, shotgunBookSheet]);

    useEffect(() => {       
        if (paymentTagging && Object.keys(paymentTagging).length !== 0) {
            setPaymentTaggingList((a) => {
                const filterA = a.filter((c) => c.UserID != paymentTagging.UserID);
                const newA = [...filterA];
                newA.push((paymentTagging))
                return newA
            })
        }
    }, [paymentTagging]);

    useEffect(() => {
        if(type.Type == "Shotgun"){
            fetchShotgunBookSheetData(moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD'))
        }else{
            fetchTeeTimeBookSheetData(moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD'))
        }
    },[type])

    useEffect(() => {
        if(bookingUserList){
            // fetchBookingDetails(bookSheet.ID || 0)    

            //Filter's User Added In BookingUser List
            // const bookedUserIds = new Set(bookingUserList.filter(u => u.UserType == 'User').map(u => u.UserID));
            // const availableUsers = MemberList.filter(u => !bookedUserIds.has(u.ID));
            // setUsersList(availableUsers);

            let idsGuest = new Set(bookingUserList.map(({ UserID }) => UserID));
            setGuestList((a) => {
                const nA = a.filter(({ ID }) => !idsGuest.has(ID));
                return nA;
            })
        }
    },[bookingUserList])


    useEffect(() => {
        if (bookSheet.Type && bookSheet.UserID) {
            getGuests(bookSheet.Type, bookSheet.UserID);
        }
    }, [bookSheet.Type, bookSheet.UserID]);

    useEffect(() => {
        if (bookSheet.Type) {
            getGuestSubCategories();
        }

        if (bookSheet.Type !== 'Guest') {
            setSelectedSubCategory('');
            setFilteredGuestsBySubCategory([]);
        }
    }, [bookSheet.Type]);


    const availableGuests = filteredGuestsBySubCategory?.filter(g => !bookingUserList.some(b => b.UserType == 'Guest' && b.UserID == g.ID));
    const availableMemberGuests = allGuests?.filter(mg => mg.UserRefID == bookSheet.UserID && !bookingUserList.some(b => b.UserType == 'UsersGuest' && b.UserID == mg.ID));

    //#endregion  --->

    //#region CONSTANTS
    const SUB_CATEGORY_MAPPING = {
        1: 'Member',
        2: 'Residential Member',
        3: 'Junior Member',
        4: 'Walk-In Guest',
        5: 'Members Guest',
        6: 'Defence Guest'
    };
    //#endregion

    const fetchBookingDetails = async(id) =>{
        try {
            setLoading(true);
            const booking = await getBookingDetails(id)
            const filteredUsers = booking.BookingUsers ?  booking.Users.filter( g => booking.BookingUsers.findIndex( f => (f.UserType == "User" && (f.UserID == g.ID) )) === -1 ) : booking.Users.filter( g =>  bookingUserList.findIndex( f => (f.UserType == "User" &&  (f.UserID == g.ID) )) === -1 );
            const filteredGuests = booking.BookingUsers ?  booking.Guests.filter( g => booking.BookingUsers.findIndex( f => (f.UserType == "Guest" && (f.UserID == g.ID) )) === -1 ) : booking.Guests.filter( g => bookingUserList.findIndex( f => (f.UserType == "Guest" && (f.UserID == g.ID) )) === -1 );
            setMemberList(booking.Users)
            setUsersList(filteredUsers)
            setGuestList(filteredGuests)
            setAllGuestsFromServer(booking.Guests);
            setMobileCodeList(booking.MobileCode)
            setDiscountPercentage(booking.DiscountPercentage);
            setVendorFees(booking.VendorFees || []);
            setVendorName(booking.VendorName || '');
            if(booking.BookingUsers && bookingUserList.length == 0) setBookingUserList(booking.BookingUsers)
            if(booking.teeTimePaymentTagging) setPaymentTaggingList(booking.teeTimePaymentTagging)
            setTrackingID(booking.TrackingID || null);
            if (booking.PaymentMode) setBookSheet(d => ({ ...d, PaymentMode: booking.PaymentMode, PaymentMethod: booking.PaymentMethod || null, ReferenceNumber: booking.ReferenceNumber || '' }));
            setLoading(false);
           
        } catch (error) {
            swal.fire({
                icon      : 'error',
                titleText : error.message
            })  
            setLoading(false);

        }
    }

    const fetchShotgunBookSheetData = async(date) => {
        try {
            const response = await getShotgunBookSheet(date);
            isInit ? setIsInit(false) : $('#tblBookSheet').KTDatatable().destroy(); 
            setShotgunBookSheet(response)
          
        } catch (err) {
            swal.fire({
                icon      : 'error',
                titleText : err.message
            })  
        }
    }
    
    const fetchTeeTimeBookSheetData = async(date) => {
        try {
            const response = await getTeeTimeBookSheet(date);
            isInit ? setIsInit(false) : $('#tblBookSheet').KTDatatable().destroy(); 
            setTeeTimeBookSheet(response)
         
        } catch (err) {
            swal.fire({
                icon      : 'error',
                titleText : err.message
            })  
        }
    }

    const fetchVerifyDate = async(date) => {
        try {
            const response = await verifyDate(date);
            updateTypeDetails('Type', response.type)
            setTeeValidationData(response?.teeTimeValidationData);
            if(response.type == "Shotgun"){
                const ddlBlock = response.shotgunBlocks.map(b => ({ value: b.ShotgunBlockID, label: b.ShotgunBlockID }));
                updateTypeDetails('Block', ddlBlock[0].label)
                setBlockData(ddlBlock);
            }           
        } catch (err) {
            swal.fire({
                icon      : 'error',
                titleText : err.message
            })  
        }
    }

    const fetchActiveGreenFeeMaster = async () => {
        try {
            const response = await getActiveGreenFeeMaster(moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD'));
            setGreenFeeMaster(response?.greenFeeMaster);
            setServerTS(response?.serverTS);
            serverTSRef.current = response?.serverTS;
            return;
        } catch (err) {
            swal.fire({
                icon      : 'error',
                titleText : err.message
            })
        }
    };

    const getGuests = async (callerType, userID) => {
        try {
            const response = await getAllGuests(callerType, userID);
            setAllGuests(response.allGuests);
            return;
        } catch (err) {
            swal.fire({
                icon      : 'error',
                titleText : err.message
            })
        }
    };

    const getGuestSubCategories = async () => {
        try {
            const response = await getGuestByCategoryID(2);
            let filteredSubCategories = null;
            if (bookSheet?.Type === 'Guest') {
                // filter for guest
                filteredSubCategories = response?.guestTypes.filter(s => s.ID !== 5 && s.ID !== 7 && s.ID !== 8);
            } else {
                // filter for Member
                filteredSubCategories = response?.guestTypes?.filter(s => s.ID !== 4 && s.ID !== 6);
            }
            setSubCategoryList(filteredSubCategories);
            return;
        } catch (err) {
            swal.fire({
                icon      : 'error',
                titleText : err.message
            })
        }
    };

    const updateTypeDetails = (field, value) => {   
        setType((d) => {
            return { ...d, [field]: value };
        });
    };

    const updateBookingDetails = (field, value) => { 
        setBookSheet((d) => {
            if (field == 'Type' && value == 'Guest') {
                const { UserID, ...rest } = d;
                return { ...rest, [field]: value };
            }
            return { ...d, [field]: value };
        });
    };

    // function exportSheet(btnType) {
    //     let fileName = `${moment(selectedDate, 'DD-MM-YYYY').format('DD-MM-YYYY')} - Tee Booking Sheet - ${type == 'Shotgun' ? 'Shotgun Start' : type.TeeBox + ' Tee Box'}`;

    //     bookingTable.update({
    //         headers: true,
    //         formats: ["xlsx", "csv"],
    //         filename: fileName // pass in a new set of properties
    //     });
        
    //     if (btnType == 'xlsx') {
    //         $('.button-default.xlsx').click();
    //     } else {
    //         $('.button-default.csv').click();
    //     }
        
    //     $('.tableexport-caption').addClass('hidden');
    // }

    function fillDataTable(teeBox) {

        swal.close();

        var check = '<img src="' + ic_check_on + '" style="height: 20px; width: 20px; float:right;"/>';
        var cart = '<img src="' + golf_cart + '" style="height: 22px; width: 22px; float:right; margin-left:5px"/>';
        var caddy = '<img src="' + golf_caddy + '" style="height: 20px; width: 20px; float:right; margin-left:5px"/>';

        var bookingList = [];

        if (teeBox == 'All') {
            bookingList = teeTimeBookSheet?.BookSheet?.sort((a, b) => {
                var c = moment(moment($('#txtDate').val(), 'DD-MM-YYYY').format("DD-MMM-YYYY") + ' ' + a.Slot, "DD-MMM-YYYY").format("DD-MMM-YYYY hh:mm A");
                var d = moment(moment($('#txtDate').val(), 'DD-MM-YYYY').format("DD-MMM-YYYY") + ' ' + b.Slot, "DD-MMM-YYYY").format("DD-MMM-YYYY hh:mm A");

                if (moment(d).isBefore(moment(c))) {
                    return 1;
                } else if (moment(c).isBefore(moment(d))) {
                    return -1;
                } else {
                    return 0;
                }
            });

        } else {
            bookingList = teeTimeBookSheet?.BookSheet?.filter(i => i.TeeBox == teeBox);
        }

        if (teeTimeBookSheet?.Holiday != null) {
            $('#lblHoliday').text("Holiday : " + teeTimeBookSheet?.Holiday.Name);
        } else {
            $('#lblHoliday').text("");
        }

        $.each(bookingList, function (index, element) {

            if (element.Player1Caddy == 'Y') {
                element["Player1"] += caddy;
            }
            if (element.Player2Caddy == 'Y') {
                element["Player2"] += caddy;
            }
            if (element.Player3Caddy == 'Y') {
                element["Player3"] += caddy;
            }
            if (element.Player4Caddy == 'Y') {
                element["Player4"] += caddy;
            }

            if (element.Player1Cart == 'Y') {
                element["Player1"] += cart;
            }
            if (element.Player2Cart == 'Y') {
                element["Player2"] += cart;
            }
            if (element.Player3Cart == 'Y') {
                element["Player3"] += cart;
            }
            if (element.Player4Cart == 'Y') {
                element["Player4"] += cart;
            }

            if (element.Player1IsPresent == 'Y') {
                element["Player1"] += check;
            }
            if (element.Player2IsPresent == 'Y') {
                element["Player2"] += check;
            }
            if (element.Player3IsPresent == 'Y') {
                element["Player3"] += check;
            }
            if (element.Player4IsPresent == 'Y') {
                element["Player4"] += check;
            }

        });

        const dataTable = $('#tblBookSheet').KTDatatable({
            data: {
                saveState: false,
                source: bookingList,
            },
            layout: {
                scroll: false,
                footer: false,
            },
            sortable: false,
            pagination: false,
            search: {
                input: $('#generalSearch'),
            },
            columns: [
                {
                    field: 'Slot',
                    title: 'Slot',
                    width: 70
                },
                {
                    field: 'TeeBox',
                    title: 'Tee',
                    width: 50
                },
                {
                    field: 'Hole',
                    title: 'Hole',
                    width: 50
                },
                {
                    field: 'Status',
                    title: 'Status',
                    width: 85,
                    template: function (row) {
                        if (row.Status == null) {
                            return "<div class='badge badge-success'><span>Available</span></div>";
                        } else {
                            return '<div class="badge badge-danger"><span>' + row.Status + '</span></div>';
                        }
                    }
                },
                {
                    field: 'OwnerType',
                    title: 'Booked by',
                    width: 90,    
                    template: function (row) {
                        // return (row?.OwnerType == "Vendor") ? (row?.VendorName || "Partner") : (row?.OwnerType ?? "");                        
                        
                        if (row?.OwnerType == "Vendor") {
                            return `<span class="kt-badge kt-badge--unified-success kt-badge--lg kt-badge--rounded kt-badge--bold book-badge" > ${row?.VendorName || "Partner"} </span>`;
                        } else if(row?.OwnerType == "Admin") {
                            return '<span class="kt-badge kt-badge--unified-primary kt-badge--lg kt-badge--rounded kt-badge--bold book-badge">' + (row?.OwnerType) + '</span>';
                        }else{
                            return (row?.OwnerType ?? "");
                        }
                    }
                },
                {
                    field: 'Player1',
                    title: 'Player 1',
                    template: function (row) {
                        if (row?.Player1) {
                            return `<span class='kt-badge kt-badge--${row.UserType1 == "User" ? 'success' : (row.UserType1 == "Guest" || row.UserType1 == "UsersGuest") ? 'warning' : 'danger'} kt-badge--dot'></span>&nbsp;&nbsp;${row.Player1}`
                        }else {
                            return '';
                        }
                    }
                },
                {
                    field: 'Player2',
                    title: 'Player 2',
                    template: function (row) {
                        if (row?.Player2) {
                            return `<span class='kt-badge kt-badge--${row.UserType2 == "User" ? 'success' : (row.UserType2 == "Guest" || row.UserType2 == "UsersGuest") ? 'warning' : 'danger'} kt-badge--dot'></span>&nbsp;&nbsp;${row.Player2}`
                        }else {
                            return '';
                        }
                    }
                },
                {
                    field: 'Player3',
                    title: 'Player 3',
                    template: function (row) {
                        if (row?.Player3) {
                            return `<span class='kt-badge kt-badge--${row.UserType3 == "User" ? 'success' : (row.UserType3 == "Guest" || row.UserType3 == "UsersGuest") ? 'warning' : 'danger'} kt-badge--dot'></span>&nbsp;&nbsp;${row.Player3}`
                        }else {
                            return '';
                        }
                    }
                },
                {
                    field: 'Player4',
                    title: 'Player 4',
                    template: function (row) {
                        if (row?.Player4) {
                            return `<span class='kt-badge kt-badge--${row.UserType4 == "User" ? 'success' : (row.UserType4 == "Guest" || row.UserType4 == "UsersGuest") ? 'warning' : 'danger'} kt-badge--dot'></span>&nbsp;&nbsp;${row.Player4}`
                        }else {
                            return '';
                        }
                    }
                },
                {
                    field: 'CreatedDate',
                    title: 'Date',
                    width: 85,
                    template: function (row) {
                        if (row.CreatedDate == null) {
                            return "";
                        } else {
                            return moment(row.CreatedDate).format('DD-MM-YYYY');
                        }
                    }
                },
                {
                    field: 'Time',
                    title: 'Time',
                    width: 100,
                    template: function (row) {
                        if (row.CreatedDate == null) {
                            return "";
                        } else {
                            return moment(row.CreatedDate).format('hh:mm:ss.SSS A');
                        }
                    }
                },
                {
                    field: 'Invoice',
                    title: 'Invoice',
                    width: 50,
                    template: function (row) {
                        if (row?.Status == "Booked" && row.TrackingID) {                            
                            const redirectUrl = (row.OwnerType == "Vendor") ? `vendor/getBookingInvoice?bookID=${row.ID}` : `payment/invoice/${row.TrackingID}`;
                            return `<a href="${apiUrl}/api/${redirectUrl}" target="_blank" class="btn btn-outline-${row.OwnerType == "Vendor"? 'success' : "primary"} btn-icon btn-circle btn-sm"> <i class="fa fa-receipt"></i> </a>`;
                        }
                        return '';
                    }
                },
                {
                    field: '',
                    title: '',
                    width: 60,
                    template: function (row) {

                        if (row.Status == "Booked" || row.Status == null) {
                            return showEditButton(row)
                        } else {
                            return '';
                        }
                    }
                },

            ],
            rows: {
                autoHide: false,
            }
        });

        $('#root .kt-grid--hor').addClass('max-width100');
        $('#tblBookSheet .kt-datatable__table').addClass('overflow-x-auto');

        Config.Core.InitPopover();
        Config.Core.GrabAndScroll('.kt-datatable__table');

        // export to excel
        // const BookingTable = $('.kt-datatable__table').tableExport({
        //     formats: ["xlsx", "csv"],
        //     headers: true,
        //     filename: `${moment().format("DD-MM-YYYY")} - Tee Booking Sheet - ${type.TeeBox} Tee Box`,
        // });
        // setBookingTable(BookingTable);
        // $('.tableexport-caption').addClass('hidden');
        
        function showEditButton(row) {
            const formattedDate = moment($('#txtDate').val(), 'DD/MM/YYYY').format('DD-MMM-YYYY');
            var optString = '';
            const isEdit = moment(moment(teeTimeBookSheet?.ServerDate).format('DD-MMM-YYYY')).isSameOrBefore(formattedDate);
            
            optString += '<center>'
            if (row.Comment) optString += `<button type="button" class="btn btn-outline-info btn-elevate btn-circle btn-icon btn-xs mr-1" data-toggle="kt-popover"  data-trigger="hover click" data-placement="left" data-original-title="Comments" data-content="${row.Comment}"><i class="fa fa-info"></i></button>`;
            if (isEdit) optString += `<button type="button"  class="btn btn-outline-info btn-elevate btn-circle btn-icon btn-xs btn-edit"><i class="flaticon2-edit"></i></button>`
            optString += '</center>'
            
            return optString;
        }

        dataTable.on('click', '.btn-edit', function (ss) {
            const index = $(ss.currentTarget).parents('tr').index();
               
            if (dataTable.dataSet && dataTable.dataSet.length > 0 && dataTable.dataSet[index]) {
                let bookingData = dataTable.dataSet[index];
                if (!bookingData?.ID) {
                    const selectedDateFormatted = moment(selectedDate, 'DD-MM-YYYY').format('DD-MM-YYYY');
                    const formattedDate = moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD');
                    let holeValue = '18';
                    const slotTime    = moment(`${selectedDateFormatted} ${bookingData?.Slot}`, 'DD-MM-YYYY h:mm A');
                    const nineHoleEndTime = moment(`${formattedDate} ${teeValidationData['9HoleEndTime']}`);
                    const eighteenHoleEndTime = moment(`${formattedDate} ${teeValidationData['18HoleEndTime']}`);
                    if (slotTime.isAfter(nineHoleEndTime) || slotTime.isAfter(eighteenHoleEndTime)) {
                        holeValue = '9';
                    }
                    bookingData.Hole = holeValue;
                }
                setBookSheet({...bookingData, Type: 'Member', Discount: '0'});
                fetchBookingDetails(dataTable.dataSet[index].ID || 0)
                setRightSideDetails(true); 
            } 
        });
    }
    
    //#region  Shotgun Sheet -
    
    function fillShotgunDataTable() {

        swal.close();

        var check = '<img src="' + ic_check_on + '" style="height: 20px; width: 20px; float:right;"/>';
        var cart = '<img src="' + golf_cart + '" style="height: 22px; width: 22px; float:right; margin-left:5px"/>';
        var caddy = '<img src="' + golf_caddy + '" style="height: 20px; width: 20px; float:right; margin-left:5px"/>';

        var bookingList = shotgunBookSheet?.BookSheet ?? [];       

        if (shotgunBookSheet?.Holiday != null) {
            $('#lblHoliday').text("Holiday : " + shotgunBookSheet?.Holiday?.Name);
        } else {
            $('#lblHoliday').text("");
        }

        $.each(bookingList, function (index, element) {

            if (element.Player1Caddy == 'Y') {
                element["Player1"] += caddy;
            }
            if (element.Player2Caddy == 'Y') {
                element["Player2"] += caddy;
            }
            if (element.Player3Caddy == 'Y') {
                element["Player3"] += caddy;
            }
            if (element.Player4Caddy == 'Y') {
                element["Player4"] += caddy;
            }

            if (element.Player1Cart == 'Y') {
                element["Player1"] += cart;
            }
            if (element.Player2Cart == 'Y') {
                element["Player2"] += cart;
            }
            if (element.Player3Cart == 'Y') {
                element["Player3"] += cart;
            }
            if (element.Player4Cart == 'Y') {
                element["Player4"] += cart;
            }

            if (element.Player1IsPresent == 'Y') {
                element["Player1"] += check;
            }
            if (element.Player2IsPresent == 'Y') {
                element["Player2"] += check;
            }
            if (element.Player3IsPresent == 'Y') {
                element["Player3"] += check;
            }
            if (element.Player4IsPresent == 'Y') {
                element["Player4"] += check;
            }

        });

        const dataTable = $('#tblBookSheet').KTDatatable({
            data: {
                saveState: false,
                source: bookingList,
            },
            layout: {
                scroll: false,
                footer: false,
            },
            sortable: false,
            pagination: false,
            search: {
                input: $('#generalSearch'),
            },
            columns: [
                {
                    field: 'Block',
                    title: 'Block',
                    width: 100
                },
                {
                    field: 'HoleNumber',
                    title: 'Hole',
                    width: 50
                },
                {
                    field: 'Status',
                    title: 'Status',
                    width: 85,
                    template: function (row) {
                        if (row.Status == null) {
                            return "<div class='badge badge-success'><span>Available</span></div>";
                        } else {
                            return '<div class="badge badge-danger"><span>' + row.Status + '</span></div>';
                        }
                    }
                },
                {
                    field: 'Player1',
                    title: 'Player 1',
                    template: function (row) {
                        if (row?.Player1) {
                            return `<span class='kt-badge kt-badge--${row.UserType1 == "User" ? 'success' : (row.UserType1 == "Guest" || row.UserType1 == "UsersGuest") ? 'warning' : 'danger'} kt-badge--dot'></span>&nbsp;&nbsp;${row.Player1}`
                        }else {
                            return '';
                        }
                    }
                },
                {
                    field: 'Player2',
                    title: 'Player 2',
                    template: function (row) {
                        if (row?.Player2) {
                            return `<span class='kt-badge kt-badge--${row.UserType2 == "User" ? 'success' : (row.UserType2 == "Guest" || row.UserType2 == "UsersGuest") ? 'warning' : 'danger'} kt-badge--dot'></span>&nbsp;&nbsp;${row.Player2}`
                        }else {
                            return '';
                        }
                    }
                },
                {
                    field: 'Player3',
                    title: 'Player 3',
                    template: function (row) {
                        if (row?.Player3) {
                            return `<span class='kt-badge kt-badge--${row.UserType3 == "User" ? 'success' : (row.UserType3 == "Guest" || row.UserType3 == "UsersGuest") ? 'warning' : 'danger'} kt-badge--dot'></span>&nbsp;&nbsp;${row.Player3}`
                        }else {
                            return '';
                        }
                    }
                },
                {
                    field: 'Player4',
                    title: 'Player 4',
                    template: function (row) {
                        if (row?.Player4) {
                            return `<span class='kt-badge kt-badge--${row.UserType4 == "User" ? 'success' : (row.UserType4 == "Guest" || row.UserType4 == "UsersGuest") ? 'warning' : 'danger'} kt-badge--dot'></span>&nbsp;&nbsp;${row.Player4}`
                        }else {
                            return '';
                        }
                    }
                },
                {
                    field: 'CreatedDate',
                    title: 'Date',
                    width: 145,
                    template: function (row) {
                        if (row.CreatedDate == null) {
                            return "";
                        } else {
                            return moment(row.CreatedDate).format('DD-MM-YYYY');
                        }
                    }
                },
                {
                    field: 'Time',
                    title: 'Time',
                    width: 145,
                    template: function (row) {
                        if (row.CreatedDate == null) {
                            return "";
                        } else {
                            return moment(row.CreatedDate).format('hh:mm:ss.SSS A');
                        }
                    }
                },
                {
                    field: '',
                    title: '',
                    width: 60,
                    template: function (row) {

                        if (row.Status == "Booked" || row.Status == null) {
                            return showEditButton(row)
                        } else {
                            return '';
                        }
                    }
                },

            ],
            rows: {
                autoHide: false,
            }
        });

        $('#root .kt-grid--hor').addClass('max-width100');
        $('#tblBookSheet .kt-datatable__table').addClass('overflow-x-auto');

        Config.Core.InitPopover();
        Config.Core.GrabAndScroll('.kt-datatable__table');

        // export to excel
        // const BookingTable = $('.kt-datatable__table').tableExport({
        //     formats: ["xlsx", "csv"],
        //     headers: true,
        //     filename: `${moment().format("DD-MM-YYYY")} - Tee Booking Sheet - ${type.TeeBox} Tee Box`,
        // });

        // setBookingTable(BookingTable);
        // $('.tableexport-caption').addClass('hidden');
        
        function showEditButton(row) {

            const formattedDate = moment($('#txtDate').val(), 'DD/MM/YYYY').format('DD-MMM-YYYY');

            var optString = '';

            const isEdit = moment(moment(shotgunBookSheet?.ServerDate).format('DD-MMM-YYYY')).isSameOrBefore(formattedDate);

            optString += '<center>'

            if (row.Comment) optString += `<button type="button" class="btn btn-outline-info btn-elevate btn-circle btn-icon btn-xs mr-1" data-toggle="kt-popover"  data-trigger="hover click" data-placement="left" data-original-title="Comments" data-content="${row.Comment}"><i class="fa fa-info"></i></button>`

            if (isEdit) optString += `<button type="button"  class="btn btn-outline-info btn-elevate btn-circle btn-icon btn-xs btn-edit"><i class="flaticon2-edit"></i></button>`

            optString += '</center>'

            return optString;
        }
        
        dataTable.on('click', '.btn-edit', function (ss) {
            const index = $(ss.currentTarget).parents('tr').index();
               
            if (dataTable.dataSet && dataTable.dataSet.length > 0 && dataTable.dataSet[index]) {
                let bookingData = dataTable.dataSet[index];


                /**@default - Shotgun is Always 18 Hole */
                setBookSheet({...bookingData, Hole:'18' ,Type: 'Member', Discount: '0'});
                fetchBookingDetails(dataTable.dataSet[index].ID || 0)
                setRightSideDetails(true); 
            } 
        });
    }


     function exportSheet(exportType){
        /* This Function Depends on XLSX lib attached in Public Index as CDN */
        let bookingList = [] ;

        if(type.Type == "Shotgun"){
            bookingList = shotgunBookSheet?.BookSheet
        }else{
            if (type.TeeBox == 'All') {
                bookingList = teeTimeBookSheet?.BookSheet?.sort((a, b) => {
                    var c = moment(moment($('#txtDate').val(), 'DD-MM-YYYY').format("DD-MMM-YYYY") + ' ' + a.Slot, "DD-MMM-YYYY").format("DD-MMM-YYYY hh:mm A");
                    var d = moment(moment($('#txtDate').val(), 'DD-MM-YYYY').format("DD-MMM-YYYY") + ' ' + b.Slot, "DD-MMM-YYYY").format("DD-MMM-YYYY hh:mm A");
    
                    if (moment(d).isBefore(moment(c))) {
                        return 1;
                    } else if (moment(c).isBefore(moment(d))) {
                        return -1;
                    } else {
                        return 0;
                    }
                });
    
            } else {
                bookingList = teeTimeBookSheet?.BookSheet?.filter(i => i.TeeBox == teeBox);
            }
        }

        //Check for empty state
        if (!bookingList || bookingList.length === 0) {
            swal.fire({ icon:'warning', titleText: 'No data to Export', showConfirmButton: false });
            return;
        }
        


        let fileName     =  `${selectedDate}_TeeSheet_${type.TeeBox}_TeeBox`;
        const exportData = getExportData(bookingList);
        
        exportToExcel(exportType, exportData, fileName);       
    }

    function getExportData(sData) {
        const removeHtml = value =>
            String(value ?? "")
                .replace(/<[^>]*>/g, "")
                .replace(/&nbsp;/gi, " ")
                .trim();
                
        return sData?.map(r => {            
            return {
                GameDate: moment(r.BookDate).format("DD-MM-YYYY"),
                Slot: r.Slot,
                Tee: r.TeeBox,
                Hole: r.Hole,
                BookDate: moment(r.CreatedDate).format("DD-MM-YYYY"),
                Booktime: moment(r.CreatedDate).format("hh:mm:ss.SSS A"),
                BookedBy: r.OwnerType === "Vendor"
                    ? (r.VendorName || "Partner")
                    : (r.OwnerType ?? ""),
                Status: r.Status?.toLowerCase() === "booked" ? "Confirm" : (r.Status ?? ""),
                Player1: removeHtml(r.Player1),
                Player2: removeHtml(r.Player2),
                Player3: removeHtml(r.Player3),
                Player4: removeHtml(r.Player4),
            };
        });
    }

    //#endregion

    const addBookingUserHandler = () => {
        if (!bookSheet?.UserID) {
            return swal.fire({
                icon               : 'warning',
                text               : "Please select a User!",
                buttonsStyling     : false,
                confirmButtonClass : 'btn btn-brand'
            });
        }
        
        if(bookingUserList.length == 4){
            return swal.fire({
                icon               : 'warning',
                text               : "Maximum 4 Players Allowed!",
                buttonsStyling     : false,
                confirmButtonClass : 'btn btn-brand'
            });
        }

        //Check If User Exist ->
        const isExist = bookingUserList.some(u => u.ID == bookSheet.UserID && u.UserType == "User");
        if (isExist) {
            return swal.fire({
                icon               : 'warning',
                text               : "User Already Added!",
                buttonsStyling     : false,
                confirmButtonClass : 'btn btn-brand'
            });
        }

        setBookingUserList((a) => {
            const newA = [...a];
            const newO = usersList.find((f) => f.ID == bookSheet.UserID)
            newA.push({...newO,  UserID: newO.ID, UserType: "User", IsCartRequired: 'N', IsCaddyRequired: 'N', SendPaymentLink: 'N'})
            return newA;
        })
        setBookSheet(a => ({...a, UserID: null , GuestID: null }))
    }

    const addBookingUserGuestHandler = () => {
        if (!selectedUserGuest) {
            return swal.fire({
                icon               : 'warning',
                text               : "Please select a Member Guest!",
                buttonsStyling     : false,
                confirmButtonClass : 'btn btn-brand'
            });
        }
        
        if(bookingUserList.length == 4){
            return swal.fire({
                icon               : 'warning',
                text               : "Maximum 4 Players Allowed!",
                buttonsStyling     : false,
                confirmButtonClass : 'btn btn-brand'
            });
        }

        //Check If Guest Exist ->
        const isExist = bookingUserList.some(u => u.ID == selectedUserGuest && u.UserType == "UsersGuest");
        if (isExist) {
            return swal.fire({
                icon               : 'warning',
                text               : "Member's Guest Already Added!",
                buttonsStyling     : false,
                confirmButtonClass : 'btn btn-brand'
            });
        }

        const memberGuest = allGuests.find(g => g.ID == selectedUserGuest);
        
        setBookingUserList(prev => ([
            ...prev,
            {
                ...memberGuest,
                UserID: memberGuest.ID,
                UserType: 'UsersGuest',
                IsCartRequired: 'N',
                IsCaddyRequired: 'N',
                SendPaymentLink: 'N'
            }
        ]));
        setSelectedUserGuest('');
    }

    const addBookingGuestHandler = () =>{
        if (!selectedGuest) {
            return swal.fire({
                icon                  : 'warning',
                text                  : "Please select a Guest!",
                buttonsStyling        : false,
                confirmButtonClass    : 'btn btn-brand',   
            });
        }

        if(bookingUserList.length == 4){
            return swal.fire({
                icon               : 'warning',
                text               : "Maximum 4 Players Allowed!",
                buttonsStyling     : false,
                confirmButtonClass : 'btn btn-brand'
            });
        }

        const guest = selectedGuest.value;

        //Check If Guest Exist ->
        const isExist = bookingUserList.some(u => u.ID == guest.ID && u.UserType == "Guest");
        if (isExist) {
            return swal.fire({
                icon               : 'warning',
                text               : "Guest Already Added!",
                buttonsStyling     : false,
                confirmButtonClass : 'btn btn-brand'
            });
        }

        setBookingUserList(prev => ([
            ...prev,
            {
                ...guest,
                UserID: guest.ID,
                UserType: "Guest",
                IsCartRequired: 'N',
                IsCaddyRequired: 'N',
                SendPaymentLink: 'N'
            }
        ]));

        paymentHandler({ ...guest, UserID: guest.ID, UserType: "Guest" });
        setSelectedGuest(null);
    }

    const addBookingHandler = async() => {

        if (bookingUserList.length > 4) {
            swal.fire({
                icon: 'warning',
                titleText: 'Limit Reached',
                text: 'You can add a maximum of 4 users to a booking',
                confirmButtonClass: 'btn btn-brand'
            });
            return;
        }

        if (!bookSheet.ID && !bookSheet?.PaymentMode) {
            return swal.fire({
                icon              : 'warning',
                titleText         : 'Settle Mode Required',
                text              : 'Please select a settle mode.',
                buttonsStyling    : false,
                confirmButtonClass: 'btn btn-brand'
            })
        }

        if (!bookSheet.ID && bookSheet.PaymentMode === 13 && !bookSheet.PaymentMethod) {
            return swal.fire({
                icon              : 'warning',
                titleText         : 'Payment Method Required',
                text              : 'Please select a Payment Method for Offline payment.',
                buttonsStyling    : false,
                confirmButtonClass: 'btn btn-brand'
            });
        }

        if (bookSheet.PaymentMode === 13 && !bookSheet.ReferenceNumber) {
            swal.fire({
                icon              : 'warning',
                titleText         : 'Reference Number Required',
                text              : 'Please enter a Reference Number for Offline payment.',
                buttonsStyling    : false,
                confirmButtonClass: 'btn btn-brand'
            });
            return;
        }

        const isPaymentLinkMode = settlementList.find(o => o.value === 14)?.value === bookSheet.PaymentMode;
        if (isPaymentLinkMode && !bookingUserList.some(u => u.SendPaymentLink === 'Y')) {
            swal.fire({
                icon              : 'warning',
                titleText         : 'No Player Selected',
                text              : 'Please select a player to send the payment link to.',
                buttonsStyling    : false,
                confirmButtonClass: 'btn btn-brand'
            });
            return;
        }
        const btn = $('#btnSave');
        helper.StartProcessing(btn);

        try {
            const bookSheetDetails = {
                ID:                 bookSheet.ID || 0,
                TemplateID:         bookSheet.TemplateID,
                Hole:               bookSheet.Hole || 18,
                BookDate:           moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD'),
                Comment:            bookSheet.Comment,
                PaymentMode:        bookSheet.PaymentMode,
                DiscountPercentage: (!bookSheet?.Discount) ? 0 : bookSheet?.Discount,
                Comment:            bookSheet.Comment,
                ReferenceNumber:    bookSheet?.ReferenceNumber,
                PaymentMethod:      bookSheet?.PaymentMode === 13 ? bookSheet?.PaymentMethod : null
            }

            let bookingUser = [];

            bookingUserList.forEach(function (e, i) {
                bookingUser.push({
                    ID:                 0, 
                    TeeTimeBookID:      bookSheet.ID || 0,
                    UserID:             e.UserID,  
                    UserType:           e.UserType,
                    IsCartRequired:     e.IsCartRequired,
                    IsCaddyRequired:    e.IsCaddyRequired,
                    SubCategoryID:      e.SubCategoryID || null,
                    SendPaymentLink:    e.SendPaymentLink 
                });
            });

            const teeTimePaymentTagging = paymentTaggingList.map((t) =>({
                ...t,
                ID:                     t.ID || 0,
                UserID:                 t.UserID,
                TeeTimeBookUserID:      0,
                ReferenceID:            t.ReferenceID || 0,
                ReferenceType:          t.ReferenceType || 'Direct',
                PaymentMode:            t.PaymentMode || 'Direct',
                ReferenceName:          t.ReferenceName || ''

            }))

            if (bookSheet.PaymentMode === 13) {
                await postTeeTimeBookOffline(bookSheetDetails, bookingUser, teeTimePaymentTagging);
            } else {
                await postTeeTimeBook(bookSheetDetails, bookingUser, teeTimePaymentTagging);
            }
            helper.StopProcessing(btn);
            setTimeout(() => {
                if(type.Type == "Shotgun"){
                    fetchShotgunBookSheetData(moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD'))
                }else{
                    fetchTeeTimeBookSheetData(moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD'))
                }
            }, 500);
            closeDrawer();
            if (bookSheetDetails.ID) {
                swal.fire({
                    toast: true,
                    icon: 'success',
                    titleText: 'Booking updated successfully!',
                    position: 'bottom-end',
                    showConfirmButton: false,
                    timer: 1500,
                    animation: false,
                    customClass: {
                        popup: 'margin-20',
                    },
                });
            }else{
                swal.fire({
                    icon: 'success',
                    titleText: 'Booking added successfully!',
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
        } catch (err) {
            helper.StopProcessing(btn);
            swal.fire({
                icon                  : 'error',
                titleText             : 'Error!',
                text                  : err.message,
                buttonsStyling        : false,
                confirmButtonClass    : 'btn btn-brand',
            });
            return;
        }
    }

    const paymentHandler = (value) => {
        if(value.UserType == 'Guest'){
            if(paymentTaggingList && paymentTaggingList.length > 0){
                setPaymentTagging(paymentTaggingList.find((f) => f.UserID == value.UserID && f.TeeTimeBookUserID == value.TeeTimeBookUserID))
            }else{
                setPaymentTagging({})
            }
            setShowAddPayment(value)
        }
    }

    const cancelBookingHandler = async() => {
        const btn = $('#btnCancel');
        helper.StartProcessing(btn);
        try {
            const isEmptyOrSpaces = bookSheet.Comment === null || bookSheet.Comment.match(/^ *$/) !== null || /\s/.test(bookSheet.Comment);

            await deleteBooking(bookSheet.ID, isEmptyOrSpaces ? null : bookSheet.Comment)
            helper.StopProcessing(btn);
            setTimeout(() => {
                if(type.Type == "Shotgun"){
                    fetchShotgunBookSheetData(moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD'))
                }else{
                    fetchTeeTimeBookSheetData(moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD'))
                }
            }, 1000);
            closeDrawer();
            swal.fire({
                icon: 'success',
                titleText: 'Booking deleted successfully!',
                showConfirmButton: false,
                timer: 1500,
            });
        } catch (err) {
            helper.StopProcessing(btn);
            swal.fire({
                icon                  : 'error',
                titleText             : 'Error!',
                text                  : err.message,
                buttonsStyling        : false,
                confirmButtonClass    : 'btn btn-brand',
            });
            return;
        }
    }

    const resetUser = () => {
        setBookSheet(a => ({...a, UserID: ''}))
    }

    const resetGuest = () => {
        setSelectedGuest(null);
    }

    const closeDrawer = () =>{
        Config.Core.CloseDrawer();
        setTimeout(() => {
            setRightSideDetails(false);
            setVendorFees([]);
            setVendorName('');
        }, 200);
    }

    const deleteUserHandler = (index, value) => {
        setBookingUserList(p => {
            const nA = p.filter((f, i) => index !== i )
            return nA
        })
        if(value.UserType == 'Guest'){
            setPaymentTaggingList(p => {
                const nA = p.filter((f) => value.UserID !== f.UserID )
                return nA
            })    
        }
    }

    const handleCartChange = (user, index, isChecked) => {

        const updatedList = [ ...bookingUserList ];
        updatedList[index] = {
            ...updatedList[index],
            IsCartRequired: isChecked ? 'Y' : 'N'
        };

        setBookingUserList(updatedList);
        return;
    };

    const handlePaymentLinkChange = (index) => {
        setBookingUserList(prev => {
            const isAlreadySelected = prev[index].SendPaymentLink === 'Y';
            return prev.map((item, i) => ({
                ...item,
                SendPaymentLink: i === index ? (isAlreadySelected ? 'N' : 'Y') : 'N'
            }));
        });
    };

    const handleCaddyChange = (user, index, isChecked) => {

        const updatedList = [ ...bookingUserList ];
        updatedList[index] = {
            ...updatedList[index],
            IsCaddyRequired: isChecked ? 'Y' : 'N'
        };


        setBookingUserList(updatedList);
        return;
    };

    const togglePaymentExpansion = () => {
        setExpandedPaymentDetails(!expandedPaymentDetails);
    };

    // use it to update payment related keys in bookSheet state
    const updateBookingPaymentDetails = (field, value) => {
        if(field == 'all'){
            setBookSheet((d)=> ({...d,...value}));
        }else{
            setBookSheet((d) => {
                return {  ...d, [field]: value };
            });
        }
    };

    // const handleTaxCalculation = (calculatedFees) => {
    //     setTaxData(calculatedFees);
    // };

    const handleSubCategoryChange = (selectedID) => {
        setSelectedSubCategory(selectedID);
        const filteredGuests = allGuestsFromServer.filter(g => g.SubCategoryID == selectedID);
        setFilteredGuestsBySubCategory(filteredGuests);
        return;
    };

    const fetchSettlementOptions = async () => {
        try {
            const response = await getAdminSettlementOptions();
            const options = response?.settlementOptions?.map(option => ({
                label: option.Name,
                value: option.ID
            }));
            setSettlementList(options?.filter(o => o.value === 13 || o.value === 14));
            setAllSettlementList(options?.filter(o => o.value !== 13 && o.value !== 14));
            return;
        } catch (err) {
            swal.fire({
                icon                  : 'error',
                titleText             : 'Error!',
                text                  : err.message,
                buttonsStyling        : false,
                confirmButtonClass    : 'btn btn-brand',
            });
            return;
        }
    };

    const isWeekend = () => {
        const day = moment(selectedDate, 'DD-MM-YYYY').day();
        return day === 0 || day === 6 ? 'Y' : 'N';
    };

    const fees = useMemo(() => {
        const weekend = isWeekend();
        const hole = parseInt(bookSheet?.Hole);

        //Helper for rounding
        const round = (num) => Math.round(Number(num.toFixed(2)));

        // Vendor booking: recompute from the locked fee calendar's rows (no discount,
        // single Tax%). Pick row by (TypeID, Hole) with same-type → first-row fallback.
        const isVendorBooking = bookSheet?.OwnerType === 'Vendor';
        if (isVendorBooking) {
            const typeID = weekend === 'Y' ? 2 : 1;
            const feeRow =
                vendorFees.find(f => f.TypeID === typeID && Number(f.Hole) === hole) ||
                vendorFees.find(f => f.TypeID === typeID) ||
                vendorFees[0] || null;

            if (!feeRow) {
                return { greenFee: 0, cart: 0, caddy: 0, tax: 0, discount: 0, total: 0, cartCount: 0, caddyCount: 0 };
            }

            let green = 0, cart = 0, caddy = 0, cartCnt = 0, caddyCnt = 0;
            bookingUserList.forEach(user => {
                green += Number(feeRow.GreenFee) || 0;
                if (user.IsCartRequired === 'Y') { cart += Number(feeRow.CartFee) || 0; cartCnt++; }
                if (user.IsCaddyRequired === 'Y') { caddy += Number(feeRow.CaddyFee) || 0; caddyCnt++; }
            });
            const sub = green + cart + caddy;
            const vTax = sub * (Number(feeRow.TaxPercent) || 0) / 100;
            return {
                greenFee: round(green),
                cart: round(cart),
                caddy: round(caddy),
                tax: round(vTax),
                discount: 0,
                total: round(sub + vTax),
                cartCount: cartCnt,
                caddyCount: caddyCnt
            };
        }

        let totalGreenFee = 0;
        let totalCart = 0;
        let totalCaddy = 0;
        let totalTax = 0;
        let discountAmount = 0;
        let cartCount = 0;
        let caddyCount = 0;

        bookingUserList.forEach(user => {
            const feeRecord = greenFeeMaster?.find(fee =>
                fee.SubCategoryID === user.SubCategoryID &&
                fee.Hole === hole &&
                fee.IsWeekend === weekend
            );

            if (!feeRecord) return;

            totalGreenFee += feeRecord.GreenFee;

            if (user.IsCartRequired === "Y") {
                totalCart += feeRecord.Cart;
                cartCount++;
            }

            if (user?.IsCaddyRequired === "Y") {
                totalCaddy += feeRecord?.Caddy || 0;
                caddyCount++;
            }

            // if (feeRecord?.GreenFee > 0 || user?.IsCartRequired === "Y") {
            //     const chargeableAmount =
            //         feeRecord.GreenFee +
            //         (user.IsCartRequired === 'Y' ? feeRecord.Cart : 0);

            //     totalTax += chargeableAmount * 0.18;
            // }
        });

        let discountPercent =
            discountPercentage ?? parseFloat(bookSheet.Discount);

        if (isNaN(discountPercent)) discountPercent = 0;

        const subtotal = totalGreenFee + totalCart + totalCaddy; // add caddy

        discountAmount = (subtotal * discountPercent) / 100;

        const discountedSubTotal = subtotal - discountAmount;
        // Tax after discount
        totalTax = discountedSubTotal * 0.18;
        const finalTotal = discountedSubTotal + totalTax;
        // const finalTotal = subtotal - discountAmount;

        if(finalTotal == 0) updateBookingPaymentDetails('PaymentMode', 13);

        return {
            greenFee: round(totalGreenFee),
            cart: round(totalCart),
            caddy: round(totalCaddy),
            tax: round(totalTax),
            discount: round(discountAmount),
            total: round(finalTotal),
            cartCount,
            caddyCount
        };

    }, [
        bookingUserList,
        greenFeeMaster,
        vendorFees,
        bookSheet.Hole,
        bookSheet.OwnerType,
        bookSheet.Discount,
        selectedDate,
        discountPercentage
    ]);

    // Vendor bookings are view-only in the admin drawer (owned & billed via the vendor portal).
    const isVendorBooking = bookSheet?.OwnerType === 'Vendor';

    return(
        <>
            <div className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor padding-tb0" id="kt_content"  >
                <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid margin-t20">
                    <div className="kt-portlet">
                        <div className="kt-portlet__body padding-t30 padding-b0">
                            
                            <div id="ControlHolder" className="kt-form kt-form--label-right padding-10" role="form">
                                <div className="row">
                                    <label className="col-form-label col-sm-1 text-right">Date </label>
                                    <div className="form-group col-xl-3 col-sm-3">
                                        <div className="input-group date">
                                            <input 
                                                id="txtDate" 
                                                name="txtDate" 
                                                type="text" 
                                                className="form-control " 
                                                placeholder="Select date" 
                                                defaultValue={moment(selectedDate, 'DD-MM-YYYY').format('DD-MM-YYYY')} 
                                            />
                                            <div className="input-group-append">
                                                <span className="input-group-text">
                                                    <i className="la la-calendar-check-o"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    {type && type?.Type != "Shotgun" ? (<>
                                        <label className="col-form-label col-sm-1 text-right pnlSlot ">Tee Box </label>
                                        <div className="form-group col-sm-2 pnlSlot ">
                                            <div>
                                                <Select 
                                                    id="ddlTeeBox" 
                                                    name="ddlTeeBox "
                                                    className="multi-custom "
                                                    defaultValue={ TeeBoxOption.find((m) => m.value[0] )  || ''}
                                                    onChange={(event) => updateTypeDetails('TeeBox', event.value)}
                                                    options={TeeBoxOption}
                                                />
                                            </div>
                                        </div>
                                    </>):(<div className="col-3"></div>)}
                                    <div className="form-group col-xl-3 col-sm-3">
                                        <div className="input-group">
                                            <div className="kt-input-icon kt-input-icon--left">
                                                <input 
                                                    type="text" 
                                                    className="form-control clientSearch" 
                                                    placeholder="Search Tee Time..." 
                                                    id="generalSearch" 
                                                />
                                                <span className="kt-input-icon__icon kt-input-icon__icon--left"><span><i className="la la-search"></i></span></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-2 col-sm-2">
                                        <div className="dropdown">
                                            <button className="btn btn-label-brand dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                Export
                                            </button>
                                            <div className="dropdown-menu " aria-labelledby="dropdownMenuButton" x-placement="bottom-start" style={{position: 'absolute', willChange: 'transform', top: '0px', left: '0px', transform: 'translate3d(0px, 38px, 0px)'}}>
                                                <button 
                                                    id="btn-export-excel" 
                                                    type="button" 
                                                    className="dropdown-item" 
                                                    onClick={() => exportSheet('xlsx')}
                                                >Excel
                                                </button>
                                                <button 
                                                    id="btn-export-csv" 
                                                    type="button" 
                                                    className="dropdown-item" 
                                                    onClick={() => exportSheet('csv')}
                                                >Csv 
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <h5 id="lblHoliday" className="lblHoliday"></h5>

                            <div id="tblBookSheet" className="table table-bordered table-hover custom-datatable"></div>

                            {rightSideDetails && (<RightSideDetails title="Book Tee Time" onCloseDrawer={closeDrawer}>
                                <div className="kt-portlet">
                                    <div className="kt-portlet__body padding-t30 padding-b0">
                                        <form id="ModalHolder" className="kt-form kt-form--label-right padding-10" role="form">
                                            <div className="form-group row">
                                                <label className="col-form-label col-lg-3">Date</label>
                                                <div className="col-xl-6 col-lg-8">
                                                    <input 
                                                        id="lblDate" 
                                                        name="lblDate" 
                                                        disabled="disabled" 
                                                        type="text" 
                                                        className="form-control" 
                                                        value={moment(selectedDate, 'DD-MM-YYYY').format('DD-MM-YYYY')} 
                                                    />
                                                </div>
                                            </div>
                                            {type && type?.Type != "Shotgun" && (<>
                                                <div id="pnlEdit" className="form-group row">
                                                    <label className="col-form-label col-lg-3">Slot <span className="red">*</span></label>
                                                    <div className="col-xl-6 col-lg-8">
                                                        <div>
                                                            <Select 
                                                                id="ddlTeeBox" 
                                                                name="ddlTeeBox"
                                                                className="multi-custom"
                                                                value={(teeTimeBookSheet && teeTimeBookSheet?.BookSheet?.length > 0 && bookSheet.TemplateID) && {label: teeTimeBookSheet?.BookSheet.find(c => c.TemplateID == bookSheet.TemplateID).Slot, value: bookSheet.TemplateID}}
                                                                onChange={(event) => updateBookingDetails('TemplateID', event.value)}
                                                                options={teeTimeBookSheet?.BookSheet?.map(a => ({
                                                                    label: a.Slot,
                                                                    value: a.TemplateID,
                                                                }))}
                                                                isDisabled={true}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </>)}

                                            {/**@desc - Shows holeNumber for shotgun */}
                                            {type && type?.Type == "Shotgun" && (<>
                                                <div id="pnlAdd" className="form-group row">
                                                    <label className="col-form-label col-lg-3"> Hole </label>
                                                    <div className="col-xl-6 col-lg-8">
                                                        <input 
                                                            id="lblSlot" 
                                                            name="lblSlot" 
                                                            disabled="disabled" 
                                                            type="text" 
                                                            className="form-control" 
                                                            value={bookSheet?.HoleNumber ?? ''}
                                                        />
                                                    </div>
                                                </div>
                                            </>)}
                                            <div className="form-group row">
                                                <label className="col-form-label col-lg-3"></label>
                                                <div className="kt-radio-inline col-xl-6 col-lg-8 margin-l10">
                                                    <label id="pnlRedio18" className="kt-radio kt-radio--brand">
                                                        <input 
                                                            type="radio" 
                                                            id="redio18" 
                                                            className="redio18" 
                                                            name="hole" 
                                                            value="18"
                                                            checked={ bookSheet.Hole == '18'} 
                                                            onChange={({ target }) => updateBookingDetails('Hole',target.value)}
                                                            disabled={ !!bookSheet?.ID || moment(serverTSRef.current).isSameOrAfter(moment(`${moment(selectedDate, 'DD-MM-YYYY').format('DD-MM-YYYY')} ${teeValidationData['18HoleEndTime']}`, 'DD-MM-YYYY hh:mm A')) } // disable radio button in update scenario or if 18 hole end time is elapsed
                                                        />
                                                            18 Holes
                                                        <span></span>
                                                    </label>
                                                
                                                   {type && type?.Type != "Shotgun" && (<>
                                                        <label className="kt-radio kt-radio--brand">
                                                            <input 
                                                                type="radio" 
                                                                id="redio9" 
                                                                className="redio9" 
                                                                name="hole" 
                                                                value="9"
                                                                checked={bookSheet.Hole == '9'}
                                                                onChange={({ target }) => updateBookingDetails('Hole',target.value)}
                                                                disabled={ !!bookSheet?.ID || moment(serverTSRef.current).isSameOrAfter(moment(`${moment(selectedDate, 'DD-MM-YYYY').format('DD-MM-YYYY')} ${teeValidationData['9HoleEndTime']}`, 'DD-MM-YYYY hh:mm A')) } // disable radio button in update scenario or if 9 hole end time is elapsed
                                                            />
                                                                9 Holes
                                                            <span></span>
                                                        </label>
                                                   </>)}    
                                                </div>
                                            </div>

                                            {!isVendorBooking && (<>
                                            <div id="pnlType" className="form-group row">
                                                <label className="col-form-label col-lg-3">Type <span className="red"></span></label>
                                                <div className="col-xl-6 col-lg-8">
                                                    <div>
                                                        <Select 
                                                            id="ddlType" 
                                                            name="ddlType"
                                                            className="multi-custom"
                                                            placeholder="Select Type"
                                                            defaultValue={ typeOption.find((m) => m.value[0] )  || ''}
                                                            onChange={(event) => updateBookingDetails('Type', event.value)}
                                                            options={typeOption}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            {bookSheet.Type == "Member" ? (
                                                <div id="UserHolder">
                                                    <div className="form-group row">
                                                        <label className="col-form-label col-lg-3">User</label>
                                                        <div className="col-xl-6 col-lg-8">
                                                            <div className="input-group" >
                                                                <div style={{width: "60%"}}  >
                                                                    <Select
                                                                        value={(() => { const u = usersList?.find(m => m.ID == bookSheet.UserID); return u ? { label: `${u.Name} (${u.Mobile})`, value: bookSheet.UserID } : ''; })()}
                                                                        onChange={(event) => updateBookingDetails('UserID', event.value)}
                                                                        name="ddlUser"
                                                                        placeholder="Select User"
                                                                        id="ddlUser"
                                                                        className="ddlUser"
                                                                        options={usersList.map(c => ({
                                                                            label: `${c.Name} (${c.Mobile})`,
                                                                            value: c.ID
                                                                        }))}
                                                                    />
                                                                </div>
                                                                <div className="input-group-append" style={{zIndex: 0}}>
                                                                    <button className="btn btn-secondary kt-select-reset" type="button" onClick={resetUser}><i className="flaticon2-delete kt-icon-sm padding-0"></i></button>
                                                                </div>
                                                                <button id="btnAddUser" className="btn btn-label-brand margin-l10 margin-r0" type="button"  onClick={addBookingUserHandler}>Add</button>
                                                                {/* <button id="btnNewUser" className="btn btn-label-brand margin-l10" type="button" data-toggle="modal" data-target="#modalUser" onClick={() => setShowAddUser(true)}>New</button> */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="form-group row">
                                                    <label className="col-form-label col-lg-3">SubCategory <span className="red">*</span></label>
                                                    <div className="col-xl-6 col-lg-8">
                                                        <div className="input-group">
                                                            <div style={{width: "60%"}}>
                                                                <Select
                                                                    name="ddlSubCategory"
                                                                    id="ddlSubCategory"
                                                                    className="ddlSubCategory"
                                                                    placeholder="Select SubCategory"
                                                                    options={subcategoryList.map(subCategory => ({
                                                                        value: subCategory.ID,
                                                                        label: subCategory.Name
                                                                    }))}
                                                                    onChange={(event) => handleSubCategoryChange(event.value)}
                                                                    value={selectedSubCategory ? {
                                                                        value: selectedSubCategory,
                                                                        label: subcategoryList.find(x => x.ID == selectedSubCategory)?.Name
                                                                    } : null}
                                                                />
                                                            </div>
                                                            <div className="input-group-append" style={{zIndex: 0}}>
                                                                <button className="btn btn-secondary kt-select-reset" type="button" onClick={() => setSelectedSubCategory('')}><i className="flaticon2-delete kt-icon-sm padding-0"></i></button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            {(bookSheet.Type == "Member" && !!bookSheet.UserID) ? (
                                                <>
                                                    <div id="UserGuestHolder">
                                                        <div className="form-group row">
                                                            <label className="col-form-label col-lg-3"> Members Guest</label>
                                                            <div className="col-xl-6 col-lg-8">
                                                                <div className="input-group">
                                                                    <div style={{width: "60%"}}>
                                                                        <Select
                                                                            value={(allGuests && allGuests.length > 0 && selectedUserGuest) ? {
                                                                                label: `${allGuests.find(m => m.ID == selectedUserGuest)?.Name} (${allGuests.find(m => m.ID == selectedUserGuest)?.Mobile})`,
                                                                                value: selectedUserGuest
                                                                            } : null }
                                                                            onChange={(event) => setSelectedUserGuest(event.value)}
                                                                            name="ddlUserGuest"
                                                                            placeholder="Select Member Guest"
                                                                            id="ddlUserGuest"
                                                                            data-live-search="true"
                                                                            className="ddlUserGuest"
                                                                            options={availableMemberGuests.map(guest => ({
                                                                                value: guest.ID,
                                                                                label: `${guest.Name} (${guest.Mobile})`
                                                                            }))}
                                                                        />
                                                                    </div>
                                                                    <div className="input-group-append"  style={{zIndex: 0}}>
                                                                        <button className="btn btn-secondary kt-select-reset" type="button" onClick={() => setSelectedUserGuest('')}><i className="flaticon2-delete kt-icon-sm padding-0"></i></button>
                                                                    </div>
                                                                    <button id="btnAddUserGuest" className="btn btn-label-brand margin-l10 margin-r0" type="button"  onClick={addBookingUserGuestHandler}>Add</button>
                                                                    <button id="btnNewUserGuest" className="btn btn-label-brand margin-l10" type="button" data-toggle="modal" data-target="#modalGuest"  onClick={() => setShowAddGuest(true)} >New</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            ): (bookSheet.Type == "Guest" && selectedSubCategory) && (<>
                                                {/*<div className="form-group row">
                                                    <label className="col-form-label col-lg-3">SubCategory <span className="red">*</span></label>
                                                </div>*/}

                                                <div id="GuestHolder" >
                                                    <div className="form-group row">
                                                        <label className="col-form-label col-lg-3">Guest</label>
                                                        <div className="col-xl-6 col-lg-8">
                                                            <div className="input-group">
                                                                <div style={{width: "60%"}}  >
                                                                    <Select
                                                                        // value={bookSheet.GuestID ? (() => {
                                                                        //     const g = filteredGuestsBySubCategory.find(x => x.ID == bookSheet.GuestID);
                                                                        //     return g ? { value: g.ID, label: `${g.Name} (${g.Mobile})`} : null
                                                                        // })() : null}
                                                                        value={selectedGuest || null}
                                                                        onChange={(event) => setSelectedGuest(event)}
                                                                        name="ddlGuest"
                                                                        placeholder="Select Guest"
                                                                        id="ddlGuest"
                                                                        data-live-search="true"
                                                                        className="ddlGuest"
                                                                        options={availableGuests.map(g => ({
                                                                            value: g,
                                                                            label: `${g.Name}  (${g.Mobile})`
                                                                        }))}
                                                                    />
                                                                </div>
                                                                <div className="input-group-append"  style={{zIndex: 0}}>
                                                                    <button className="btn btn-secondary kt-select-reset" type="button" onClick={resetGuest}><i className="flaticon2-delete kt-icon-sm padding-0"></i></button>
                                                                </div>
                                                                <button id="btnAddGuest" className="btn btn-label-brand margin-l10 margin-r0" type="button" onClick={addBookingGuestHandler}>Add</button>
                                                                <button id="btnNewGuest" className="btn btn-label-brand margin-l10" type="button" data-toggle="modal" data-target="#modalGuest"  onClick={() => setShowAddGuest(true)} >New</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>)}
                                            </>)}
                                            <div className="form-group row">
                                                <label className="col-form-label col-lg-3">Comment</label>
                                                <div className="col-xl-6 col-lg-8">
                                                    <textarea 
                                                        id="txtComment"
                                                        name="txtComment"
                                                        className="form-control"
                                                        rows="3"
                                                        value={bookSheet.Comment || ''}
                                                        disabled={isVendorBooking}
                                                        onChange={(event) => updateBookingDetails('Comment', event.target.value)}
                                                    ></textarea>
                                                </div>
                                            </div>
                                        </form>
                                        {/* User table */}
                                        {loading ? <Loading/> : bookingUserList && bookingUserList.length > 0 && (<table id="table-user" className="table table-bordered table-hover margin-b30">
                                            <thead className="light-grey-background">
                                                <tr>
                                                    <th>Players</th>
                                                    <th>Category</th>
                                                    <th>Cart</th>
                                                    {settlementList.find(o => o.value === 14)?.value === bookSheet.PaymentMode && <th>Send Payment Link</th>}
                                                    <th>Caddy</th>
                                                    <th className="text-center">Action</th>
                                                </tr>
                                            </thead>
                                                <tbody>
                                                    {bookingUserList.map((m, i) => (
                                                        <tr key={i}>
                                                            <td onClick={() => {!m.TeeTimeBookID  && paymentHandler(m)}}><span className={`kt-badge kt-badge--${m.UserType == "User" ? 'success' : (m.UserType == "Guest" || m.UserType == "UsersGuest") ? 'warning' : 'danger'} kt-badge--dot`}></span>&nbsp; &nbsp;{m.UserName || m.Name}{m.UserType == "Guest" && !m.TeeTimeBookID && ` (G) - ${(paymentTaggingList.length > 0 && paymentTaggingList.find(f => f.UserID == m.UserID && (f.TeeTimeBookUserID == m.TeeTimeBookUserID || f.TeeTimeBookUserID == m.ID)) ? paymentTaggingList.find(f => f.UserID == m.UserID).TagTo : "Direct")}`}</td>
                                                            <td>{m.SubCategoryName}</td>
                                                            <td className="padding-0">
                                                                <span className="kt-switch kt-switch--sm kt-switch--icon padding-l5">
                                                                    <label className="margin-b0">
                                                                    <input 
                                                                    id="chkCart"
                                                                    name="chkCart"
                                                                    type="checkbox"
                                                                    checked={m.IsCartRequired === 'Y'}
                                                                    disabled={isVendorBooking}
                                                                    onChange={(e) => handleCartChange(m, i, e.target.checked)}
                                                                    />
                                                                    <span></span>
                                                                    </label>
                                                                </span>
                                                            </td>
                                                            {settlementList.find(o => o.value === 14)?.value === bookSheet.PaymentMode && (
                                                                <td className="padding-0">
                                                                    <span className="kt-switch kt-switch--sm kt-switch--icon padding-l5">
                                                                        <label className="margin-b0">
                                                                            <input
                                                                                id={`chkPaymentLink_${i}`}
                                                                                name="chkPaymentLink"
                                                                                type="checkbox"
                                                                                checked={m.SendPaymentLink === 'Y'}
                                                                                onChange={() => handlePaymentLinkChange(i)}
                                                                            />
                                                                            <span></span>
                                                                        </label>
                                                                    </span>
                                                                </td>
                                                            )}
                                                            {(m.UserType == 'Guest') ? <td className="padding-0">
                                                                <span className="kt-switch kt-switch--sm kt-switch--icon padding-l5">
                                                                    <label className="margin-b0">
                                                                    <input
                                                                    id="chkCaddy"
                                                                    name="chkCaddy"
                                                                    type="checkbox"
                                                                    checked={m.IsCaddyRequired === 'Y'}
                                                                    disabled={isVendorBooking}
                                                                    onChange={(e) => handleCaddyChange(m, i, e.target.checked)}
                                                                    />
                                                                    <span></span>
                                                                    </label>
                                                                </span>
                                                            </td> : <td></td>}
                                                            {/* <td></td> */}
                                                            <td>
                                                                <center>
                                                                    <button className="btn btn-outline-info btn-elevate btn-circle btn-icon btn-xs margin-r10 btn-user-delete" type="button" disabled={isVendorBooking} onClick={() => deleteUserHandler(i, m)} >
                                                                        <i className="flaticon2-rubbish-bin-delete-button"></i>             
                                                                    </button>
                                                                </center>
                                                            </td>
                                                        </tr>
                                                    )
                                                    )}
                                                </tbody>                              
                                            <tfoot></tfoot>
                                        </table>)}
                                        {/* payment detail */}
                                        {bookingUserList && bookingUserList.length > 0 && (
                                            <div className="card mt-3">
                                                <div className={`card-header d-flex justify-content-between align-items-center cursor-pointer ${expandedPaymentDetails ? 'active-header bg-light' : ''}`}
                                                     onClick={togglePaymentExpansion}
                                                     aria-expanded={expandedPaymentDetails} 
                                                >
                                                    <div style={{ flex: 1, textAlign: "center", fontWeight: "bold", color: expandedPaymentDetails ? '#5d78ff' : 'inherit' }}>
                                                        Payment Details
                                                    </div>
                                                    <div className="card-title margin-b0">
                                                        <i
                                                        className="fa fa-chevron-right"
                                                        style={{
                                                            transform: expandedPaymentDetails ? 'rotate(90deg)' : 'rotate(0deg)', 
                                                            transition: 'transform 0.3s',
                                                            color: expandedPaymentDetails ? '#5d78ff' : 'inherit'
                                                        }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className={`collapse ${expandedPaymentDetails ? "show" : ""}`}>
                                                    <div className="card-body">
                                                        {/* Discount section */}
                                                        <div className="form-group row">
                                                            <label className="col-form-label col-sm-3 text-right">Discount %</label>
                                                            <div className="col-6 input-group">
                                                                <input
                                                                    id="txtDiscount"
                                                                    name="txtDiscount"
                                                                    type="number"
                                                                    className="form-control"
                                                                    disabled={bookSheet.ID}
                                                                    value={bookSheet?.ID ? (discountPercentage ?? 0) : (bookSheet.Discount ?? 0)}
                                                                    onWheel={(e) => e.currentTarget.blur()}
                                                                    onChange={(event) => {
                                                                        let value = event.target.value;
                                                                        if (value > 99.9) value = 99.9;
                                                                        if (value < 0 || !value) value = 0;
                                                                        updateBookingPaymentDetails('Discount', value);
                                                                    }}
                                                                />
                                                                <div className="input-group-append">
                                                                    <span className="input-group-text">
                                                                        <i className="flaticon2-percentage"></i>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/* Payment mode */}
                                                        {!bookSheet.ID && (
                                                            <>
                                                                <div className="form-group row">
                                                                    <label className="col-form-label col-lg-3 text-right">Settle Mode</label>
                                                                    <div className="col-6">
                                                                        <Select
                                                                            options={settlementList}
                                                                            value={settlementList.find(option => option.value === bookSheet.PaymentMode) || null }
                                                                            onChange={(event) => updateBookingPaymentDetails('PaymentMode', event.value)}
                                                                            name="ddlPaymentMode"
                                                                            placeholder="Select Settle Mode"
                                                                            id="ddlPaymentMode"
                                                                            className="ddlPaymentMode"
                                                                            isDisabled={(!!fees && fees?.total == 0)}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                {bookSheet.PaymentMode === 13 && (
                                                                    <div className="form-group row">
                                                                        <label className="col-form-label col-lg-3 text-right">Payment Method</label>
                                                                        <div className="col-6">
                                                                            <Select
                                                                                options={allSettlementList}
                                                                                value={allSettlementList.find(option => option.value === bookSheet.PaymentMethod) || null}
                                                                                onChange={(event) => updateBookingPaymentDetails('PaymentMethod', event.value)}
                                                                                name="ddlPaymentMethod"
                                                                                placeholder="Select Payment Method"
                                                                                id="ddlPaymentMethod"
                                                                                className="ddlPaymentMethod"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                )}
                                                                {bookSheet.PaymentMode === 13 && (
                                                                    <div className="form-group row">
                                                                        <label className="col-form-label col-lg-3 text-right">Reference Number</label>
                                                                        <div className="col-6">
                                                                            <input
                                                                                id="txtReferenceNumber"
                                                                                name="txtReferenceNumber"
                                                                                type="text"
                                                                                className="form-control"
                                                                                placeholder="Enter Reference Number"
                                                                                value={bookSheet.ReferenceNumber || ''}
                                                                                onChange={(e) => updateBookingPaymentDetails('ReferenceNumber', e.target.value)}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </>
                                                        )}
                                                        {bookSheet.ID && bookSheet.PaymentMode === 13 && (
                                                            <>
                                                                <div className="form-group row">
                                                                    <label className="col-form-label col-lg-3 text-right">Payment Method</label>
                                                                    <div className="col-xl-6 col-lg-8">
                                                                        <Select
                                                                            options={allSettlementList}
                                                                            value={allSettlementList.find(option => option.value === bookSheet.PaymentMethod) || null}
                                                                            isDisabled={true}
                                                                            placeholder="Select Payment Method"
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="form-group row">
                                                                    <label className="col-form-label col-lg-3 text-right">Reference Number</label>
                                                                    <div className="col-xl-6 col-lg-8">
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            value={bookSheet.ReferenceNumber || ''}
                                                                            disabled
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )}
                                                        {/* Comment */}
                                                        {/* Comment section exists above this is not needed - check with prathamesh sir */}
                                                        {/* <div className="form-group row">
                                                            <label className="col-form-label col-lg-3 text-right">Comment</label>
                                                            <div className="col-xl-6 col-lg-8">
                                                                <textarea
                                                                    id="txtComment"
                                                                    name="txtComment"
                                                                    className="form-control"
                                                                    rows="3"
                                                                    value={bookSheet.Comment || ''}
                                                                    onChange={(event) => updateBookingDetails('Comment', event.target.value)}
                                                                ></textarea>
                                                            </div>
                                                        </div> */}
                                                        {/* Tax table */}
                                                        {/* <table className="table table-bordered table-hover margin-b30">
                                                            <thead className="light-grey-background">
                                                                <tr>
                                                                    <th>Description</th>
                                                                    <th className="text-right">Amount (₹)</th>
                                                                </tr>
                                                            </thead>
                                                        </table> */}
                                                        <TaxTableTeeTime
                                                            // discountPercentage={discountPercentage}
                                                            // bookSheet={bookSheet}
                                                            // bookingUserList={bookingUserList}
                                                            // greenFeeMaster={greenFeeMaster}
                                                            // currentDate={selectedDate}
                                                            // onTaxCalculated={handleTaxCalculation}
                                                            fees = {fees}                                                    
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        <div className="row margin-bl5">
                                            <div className="col-sm-12 pl-0">
                                                <h6 className="margin-0">
                                                    <strong id="lblOwner">
                                                        {isVendorBooking
                                                            ? 'Booked By ' + (vendorName || 'Vendor')
                                                            : (bookingUserList && bookingUserList.length > 0 && bookingUserList[0].UserName && 'Booked By ' + (bookSheet.OwnerType == 'Admin' ? 'Admin' : (bookingUserList.find(user => user.IsOwner === 'Y')?.UserName || bookingUserList[0].UserName)))
                                                        }
                                                    </strong>
                                                </h6>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="kt-portlet__foot">
                                        <div className="kt-form__actions">
                                            <div className="row">
                                                <div className="col-lg-12 text-right">
                                                    {!isVendorBooking && <button id="btnSave" type="button" className="btn btn-brand d-inline-block" onClick={addBookingHandler}>{bookSheet.ID ? 'Update Booking' : 'Save Booking' }</button>}
                                                    {!isVendorBooking && bookSheet && bookSheet.ID && <button id="btnCancel" type="button" className="btn btn-warning d-inline-block margin-l10" onClick={cancelBookingHandler}>Cancel Booking</button>}
                                                    {isVendorBooking && bookSheet && bookSheet.ID && <button id="btnViewInvoice" type="button" className="btn btn-success d-inline-block margin-l10" onClick={() => window.open(`${apiUrl}/api/vendor/getBookingInvoice?bookID=${bookSheet.ID}`, '_blank', 'noreferrer')}>View Invoice</button>}
                                                    {!isVendorBooking && bookSheet && bookSheet.ID && trackingID && <button id="btnViewInvoice" type="button" className="btn btn-success d-inline-block margin-l10" onClick={() => window.open(`${apiUrl}/api/payment/invoice/${trackingID}`, '_blank', 'noreferrer')}>View Invoice</button>}
                                                    <button id="btnCloseDrawer" type="button" className="btn btn-secondary margin-l10" onClick={closeDrawer}>Close</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </RightSideDetails>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {showAddUser && (
                <AddUser
                    show={showAddUser}
                    onDismissModal={setShowAddUser}                   
                />
            )}
            {showAddGuest && (
                <AddGuest
                    show={showAddGuest}
                    onDismissModal={setShowAddGuest} 
                    setShowAddPayment={setShowAddPayment}
                    // UserRefID={bookSheet?.UserID ? bookSheet.UserID : null}
                    UserRefID={(bookSheet?.Type == "Member" && bookSheet?.UserID) ? bookSheet?.UserID : (bookSheet?.Type == "Guest") ? null : null} 
                    CategoryID={bookSheet?.Type == "Member" ? 1 : 2}
                    mobileCodeList={mobileCodeList}
                    fetchBookingDetails={() => fetchBookingDetails(bookSheet.ID || 0)} 
                    bookingUserList={bookingUserList}
                    setBookingUserList={setBookingUserList}
                    MemberList={MemberList}
                    subcategoryList={subcategoryList}
                />
            )}
            {(showAddPayment && Object.keys(showAddPayment).length !== 0) && (
                <AddPayment
                    show={showAddPayment}
                    MemberDetails={showAddPayment}
                    onDismissModal={setShowAddPayment} 
                    setPaymentTagging={setPaymentTagging} 
                    paymentTagging={paymentTagging} 
                    MemberList={MemberList} 
                />
            )}
        </>
    )
}
export default BookingSheet;